var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-45.4545 0 0 -45.4545 500.0004 500.0005)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "white",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -12)",
    d: "M 20 12 a 1 1 0 0 0 -1 -1 H 11.41 l 2.3 -2.29 a 1 1 0 1 0 -1.42 -1.42 l -4 4 a 1 1 0 0 0 -0.21 0.33 a 1 1 0 0 0 0 0.76 a 1 1 0 0 0 0.21 0.33 l 4 4 a 1 1 0 0 0 1.42 0 a 1 1 0 0 0 0 -1.42 L 11.41 13 H 19 A 1 1 0 0 0 20 12 Z M 17 2 H 7 A 3 3 0 0 0 4 5 V 19 a 3 3 0 0 0 3 3 H 17 a 3 3 0 0 0 3 -3 V 16 a 1 1 0 0 0 -2 0 v 3 a 1 1 0 0 1 -1 1 H 7 a 1 1 0 0 1 -1 -1 V 5 A 1 1 0 0 1 7 4 H 17 a 1 1 0 0 1 1 1 V 8 a 1 1 0 0 0 2 0 V 5 A 3 3 0 0 0 17 2 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.4489298ee3191e50a3772f7052e39934.svg";
export { ForwardRef as ReactComponent };